import api from '@/utils/api'

const controller = 'Template'
export default Object.assign({}, api.GetCrud(controller, null), {})
